if(process.env.NODE_ENV === 'production'){
    module.exports = require('./configureStore.prod');
}
else{
    module.exports = require('./configureStore.dev');
}

/*
    attenzione qui non esiste un export default
    quindi bisogna indicare nell'index.js
    eslint-disable import/default
    altrimenti lint continua a dare errore
*/


// WEBPACK FOOTER //
// ./src/store/configureStore.js